'use client'

import type { ReactNode } from 'react'
import { useAuthModalLinkClick } from './use-auth-modal'

/**
 * A "Start free" link a server component can render: a real link to
 * `/sign-up` that, once hydrated, opens the auth modal in place on a plain
 * click (`useAuthModalLinkClick`).
 */
export function AuthModalLink({
  href = '/sign-up',
  className,
  children,
}: {
  href?: string
  className?: string
  children: ReactNode
}) {
  const handleClick = useAuthModalLinkClick()
  return (
    <a href={href} onClick={handleClick} className={className}>
      {children}
    </a>
  )
}
